import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";

import Divider from "@mui/material/Divider";
import { Button, Grid, Typography } from "@mui/material";
import { Start } from "@mui/icons-material";
import { useSelector } from "react-redux";

const drawerWidth = 700;

const DrawerHeader = styled("div")(({ theme }) => {
  const profile = useSelector((state) => state.profileSlice.profile);

  return {
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(profile && !profile.email_verified ? 8 : 0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: "flex-start",
  };
});

const DelendDrawer = ({
  open,
  title,
  subtitle,
  handleCloser,
  children,
  endButton,
}) => {
  return (
    <Drawer
      sx={{
        width: drawerWidth,
        flexShrink: 0,
        "& .MuiDrawer-paper": {
          width: drawerWidth,
        },
      }}
      anchor="right"
      open={open}
      onClose={handleCloser}
    >
      <DrawerHeader />
      <Divider />
      {/* Make work here */}
      <Box width="auto" margin="22px 26px">
        <Grid container spacing={2}>
          <Grid item xs={12} display="flex" alignItems="start">
            <Button onClick={handleCloser}>
              <Start sx={{ mr: "8px", color: "#5E708A" }} />
            </Button>

            <Box>
              <Box sx={{ pb: 1 }}>
                <Typography fontWeight="500" fontSize="24px">
                  {title}
                </Typography>
              </Box>
              <Box>
                <Typography fontWeight="400" fontSize="14px" color={"#8087A6"}>
                  {subtitle}
                </Typography>
              </Box>
            </Box>

            <Box sx={{ flexGrow: 1 }} />

            {endButton}
          </Grid>
          <Grid item xs={12}>
            {children}
          </Grid>
        </Grid>
      </Box>
    </Drawer>
  );
};

export default DelendDrawer;
